import { render, staticRenderFns } from "./AboutMeEnhanced.vue?vue&type=template&id=2be9ecd3&scoped=true"
import script from "./AboutMeEnhanced.vue?vue&type=script&lang=js"
export * from "./AboutMeEnhanced.vue?vue&type=script&lang=js"
import style0 from "./AboutMeEnhanced.vue?vue&type=style&index=0&id=2be9ecd3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2be9ecd3",
  null
  
)

export default component.exports